import { render, staticRenderFns } from "./Idle.vue?vue&type=template&id=2adba841&scoped=true"
import script from "./Idle.vue?vue&type=script&lang=js"
export * from "./Idle.vue?vue&type=script&lang=js"
import style0 from "./Idle.vue?vue&type=style&index=0&id=2adba841&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adba841",
  null
  
)

export default component.exports